import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { selectUserType } from '../../../layout/store/slice'
import { COMPONENTS } from '../../../routers/constants'
import { USER_TYPE } from '../../../utils/authorization'
import { TextLink } from '../../html/TextLink'
import { Icon } from '../../html/icon'
import { PopupAction } from '../PopupAction'
import classes from './index.module.scss'

export const PopupExistedSubscription = ({
  isShow,
  setIsShow,
  additionNewSubscriptionData,
  onClosePopupParent,
}) => {
  const navigate = useNavigate()
  const currentUserType = useSelector(selectUserType)

  const isStandard = currentUserType.userTypeId === USER_TYPE.STANDARD

  const handleClose = () => {
    setIsShow(false)
  }

  const onClick = () => {
    if (additionNewSubscriptionData?.snpOrderId) {
      navigate(
        COMPONENTS.userManagement.components.subscriptionPayment.components
          .requestDetail.route +
          '?requestId=' +
          additionNewSubscriptionData.snpOrderId,
      )
      setIsShow(false)
    }
    if (onClosePopupParent) onClosePopupParent(false)
  }

  return (
    <PopupAction
      isShow={isShow}
      btnCancel={{
        label: 'common.CLOSE',
        isI18n: true,
        event: handleClose,
      }}
      handleClose={handleClose}
    >
      <div className={classes.popupAlertErrorContainer}>
        <Icon
          className="icon-alert"
          style={{ color: '#E8B714', fontSize: 38 }}
        />
        <div className={classes.messageContainer}>
          {isStandard ? (
            <Translate value="subscriptionPayment.EXISTED_SUBSCRIPTION_STANDARD_MESSAGE" />
          ) : (
            <TextLink
              id={'existedOrderSubscription'}
              isTextDecoration={false}
              onClick={onClick}
              value="subscriptionPayment.EXISTED_ORDER_SUBSCRIPTION_MESSAGE"
              labelLink="userProfile.HERE"
            />
          )}
        </div>
      </div>
    </PopupAction>
  )
}

PopupExistedSubscription.propTypes = {
  isShow: PropTypes.bool,
  setIsShow: PropTypes.func,
  additionNewSubscriptionData: PropTypes.object,
  onClosePopupParent: PropTypes.func,
}
